/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_GoogleInputs */

const cs_settings_calendar_google = /** @type {(inputs: Settings_Calendar_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google účet`)
};

const en_settings_calendar_google = /** @type {(inputs: Settings_Calendar_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google account`)
};

/**
* | output |
* | --- |
* | "Google account" |
*
* @param {Settings_Calendar_GoogleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_google = /** @type {((inputs?: Settings_Calendar_GoogleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_GoogleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_google(inputs)
	return cs_settings_calendar_google(inputs)
});